import React from "react";

function useDerivations() {
  const [areDerivationsToggled, setAreDerivationsToggled] =
    React.useState(false);

  return {
    areDerivationsToggled,
    toggleDerivations: () =>
      setAreDerivationsToggled((isToggled) => !isToggled),
  };
}

export { useDerivations };
